"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cookie = Cookie;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Cookie(_ref) {
  var id = _ref.id,
    show = _ref.show,
    onDisagree = _ref.onDisagree,
    onAgree = _ref.onAgree,
    handleNewPasscode = _ref.handleNewPasscode;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    id: id,
    show: show,
    centered: true,
    className: "cookie-modal"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: "bg-primary text-white modal-variant"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, "We use cookies")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("p", null, "We use cookies and other tracking technologies to better personalize content for you and to analyze our traffic. Ok by you?")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: "d-flex justify-content-center flex-row-reverse"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "primary",
    type: "button",
    className: "shadow-none text-white",
    onClick: onAgree
  }, "Agree"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "light",
    type: "button",
    className: "shadow-none ",
    onClick: onDisagree
  }, "Turn Off")));
}
var _default = Cookie;
exports.default = _default;